import { useState } from 'react';

import { isTabletOrNarrower, useWindowSize } from 'lib/hooks/useWindowSize';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';

import modalBackground from 'assets/Images/modal-background.png';

import SummaryContent from './SummaryContent';

const MobilePaymentSummary = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { device } = useWindowSize();
  // The bottom sheet is a touch pattern; wider screens get the standard right-side panel.
  const isSheet = isTabletOrNarrower(device);

  return (
    <div className="flex content-center items-center justify-center gap-3">
      <Button
        variant="tertiary"
        size="small"
        icon="ai-summary-mono"
        color="neutral"
        text="View payment summary"
        onClick={() => setIsOpen(true)}
      />
      <Modal
        isOpen={isOpen}
        handleClose={() => setIsOpen(false)}
        title="Payment summary"
        width="small"
        slideFromRight={!isSheet}
        slideFromBottom={isSheet}
        overlayClassName={isSheet ? '!p-0' : undefined}
        className={
          isSheet
            ? '!m-0 !mb-[var(--keyboard-inset,0px)] !h-[calc(var(--app-height,100dvh)*0.7)] !w-full !max-w-full !rounded-b-none'
            : undefined
        }
        bodyClassName="!p-0"
        footerClassName="h-fit"
        footer={
          <div className="flex w-full justify-end">
            <Button
              text="Close"
              size="medium"
              color="neutral"
              style="outlined"
              onClick={() => setIsOpen(false)}
            />
          </div>
        }>
        <div className="relative flex min-h-full flex-col gap-6 p-4">
          <span className="pointer-events-none absolute inset-0 overflow-hidden">
            <img
              src={modalBackground}
              alt=""
              aria-hidden="true"
              loading="lazy"
              decoding="async"
              className="h-full w-full select-none object-cover"
            />
          </span>
          <div className="relative flex flex-col gap-6">
            <SummaryContent {...props} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MobilePaymentSummary;
